module.exports = __webpack_public_path__ + "img/logo-dark.2b4d4a1a.svg";